import { REACTIONS } from "../constants/reactions";

// Purely presentational — renders each non-zero reaction as its own flex
// item (not its own wrapping container) so it can wrap alongside whatever
// row the caller places it in (see PostCard/PostStatic action rows).
export default function ReactionCounts({ reactionCounts }) {
  if (!reactionCounts) return null;

  const entries = REACTIONS.map((r) => ({ ...r, count: reactionCounts[r.type] || 0 })).filter(
    (r) => r.count > 0
  );

  if (entries.length === 0) return null;

  return (
    <>
      {entries.map((r) => (
        <span
          key={r.type}
          className="flex items-center gap-1 text-sm text-gray-600"
          aria-label={`${r.count} ${r.label} reaction${r.count === 1 ? "" : "s"}`}
        >
          <span aria-hidden="true">{r.emoji}</span>
          <span>{r.count}</span>
        </span>
      ))}
    </>
  );
}
